import { lazyChunk } from "@/lib/chunk-recovery";
import { createFileRoute } from "@tanstack/react-router";

import { seoLinks, ogImage } from "@/lib/seo";

const title = "Preguntas frecuentes del colegio | SIS Estepona";
const description =
  "Respuestas a las dudas más habituales sobre el currículo sueco, la admisión, las tarifas, la jornada escolar, el comedor y la mudanza a la Costa del Sol.";

const FaqPage = lazyChunk(() =>
  import("@/components/site/FaqPage").then((m) => ({ default: m.FaqPage })),
);

export const Route = createFileRoute("/es/preguntas-frecuentes")({
  head: () => ({
    meta: [
      { title },
      { name: "description", content: description },
      { property: "og:title", content: title },
      { property: "og:description", content: description },
      { property: "og:type", content: "article" },
      { name: "twitter:card", content: "summary_large_image" },
      { property: "og:locale", content: "es_ES" },
      ...ogImage(),
    ],
    links: seoLinks("/es/preguntas-frecuentes"),
  }),
  component: PreguntasFrecuentes,
});

function PreguntasFrecuentes() {
  return <FaqPage locale="es" />;
}
